/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_home_hero_cta_scroll = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scroll to discover`)
};

const es_home_hero_cta_scroll = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desliza para descubrir`)
};

const de_home_hero_cta_scroll = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scrollen zum Entdecken`)
};

const nl_home_hero_cta_scroll = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scroll om te ontdekken`)
};

const fr_home_hero_cta_scroll = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faites défiler pour découvrir`)
};

const it_home_hero_cta_scroll = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scorri per scoprire`)
};

const pt_br2_home_hero_cta_scroll = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role para descobrir`)
};

const pt_home_hero_cta_scroll = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deslize para descobrir`)
};

const ja_home_hero_cta_scroll = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スクロールして発見`)
};

const zh_home_hero_cta_scroll = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`滚动以发现`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const home_hero_cta_scroll = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_hero_cta_scroll(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("home_hero_cta_scroll", locale)
	if (locale === "en") return en_home_hero_cta_scroll(inputs)
	if (locale === "es") return es_home_hero_cta_scroll(inputs)
	if (locale === "de") return de_home_hero_cta_scroll(inputs)
	if (locale === "nl") return nl_home_hero_cta_scroll(inputs)
	if (locale === "fr") return fr_home_hero_cta_scroll(inputs)
	if (locale === "it") return it_home_hero_cta_scroll(inputs)
	if (locale === "pt-BR") return pt_br2_home_hero_cta_scroll(inputs)
	if (locale === "pt") return pt_home_hero_cta_scroll(inputs)
	if (locale === "ja") return ja_home_hero_cta_scroll(inputs)
	return zh_home_hero_cta_scroll(inputs)
};